import { getFixedGatsbyImage, getFluidGatsbyImage } from 'gatsby-storyblok-image';

export const fluidImage = (image, params) => {
  let imageSource = image;
  if (typeof imageSource === 'string' && imageSource.startsWith('http')) {
    imageSource = imageSource.substr(imageSource.indexOf('/'));
  }

  const fluidProps = getFluidGatsbyImage(imageSource, { ...params });
  return fluidProps;
};
export const fixedImage = (image, params) => {
  let imageSource = image;
  if (typeof imageSource === 'string' && imageSource.startsWith('http')) {
    imageSource = imageSource.substr(imageSource.indexOf('/'));
  }

  const fixedProps = getFixedGatsbyImage(imageSource, { ...params });
  return fixedProps;
};
